import type { Result } from '@/lib/models'

export function saveToLocalStorage<T>(data: T, localstorageKey: string) {
	let message = 'localstorageKey is required to save to localStorage'
	if (!localstorageKey || localstorageKey.length === 0) {
		return { success: false, message }
	}
	if (typeof window === 'undefined') {
		return { success: false, message: 'window is undefined' }
	}
	try {
		localStorage.setItem(localstorageKey, JSON.stringify(data))
	} catch (e) {
		message = `failed to save mapDeployments to localStorage ${e}`
	}
	return {
		success: false,
		message,
	}
}

export function getJSONFromLocalStorage<T>(localstorageKey: string): Result<T> {
	if (typeof window === 'undefined') {
		return {
			success: false,
			message:
				'localstorageKey is required to get data from localStorage',
		}
	}

	const localData = localStorage.getItem(localstorageKey)
	if (localData) {
		try {
			const parsed = JSON.parse(localData) as T

			return { success: true, data: parsed }
		} catch (e) {
			return {
				success: false,
				message: `failed to parse mapDeployments from localStorage ${e}`,
			}
		}
	}

	return { success: false, message: 'No data in localStorage' }
}
